var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonPage',[_c('h1',{staticStyle:{"color":"#fff","text-align":"center","font-size":"50px"}},[_vm._v(" 404 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }